import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"

const useActiveHash = () => {
    const location = useLocation()
    const [activeHash, setActiveHash] = useState(location.hash)

    useEffect(() => {
        const handleHashChange = () => {
            setActiveHash(window.location.hash)
        }

        handleHashChange()

        window.addEventListener("hashchange", handleHashChange)

        return () => {
            window.removeEventListener("hashchange", handleHashChange)
        }
    }, [location])

    return activeHash
}

export default useActiveHash
